export default function Table({commitments}){
    return (
        <div className="divGroup" style={{overflowX: "scroll", maxWidth: "100%"}}>
            <table>
                <thead>
                    <tr>
                        <th scope="col">Produto</th>
                        <th scope="col">Cliente</th>
                        <th scope="col">Total Empenhado</th>
                    </tr>
                </thead>
                <tbody>
                    {commitments?.map((commitment, index) => {
                        console.log(commitment)
                        return (
                            <tr key={index}>
                                <td colSpan={1}>{commitment?.codigo_produto} - {commitment?.produto}</td>
                                <td colSpan={1}>{commitment?.cliente}</td>
                                <td colSpan={1}>{commitment?.empenhado}</td>
                            </tr>
                        )
                    })}
                    {commitments?.length === 0 && 
                        <tr>
                            <td colSpan={7}><label className='required'>Nenhum registro encontrado!</label></td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}